import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { Grid } from '../Grid/index.js';

var DialogLayout = forwardRef(function DialogLayout(_a, ref) {
    var sx = _a.sx, _b = _a.scrollableBody, scrollableBody = _b === void 0 ? true : _b, props = __rest(_a, ["sx", "scrollableBody"]);
    var mergeStyles = useTheme().mergeStyles;
    var dialogMarginXs = "16px";
    var dialogMargin = "24px";
    var baseStyle = mergeStyles([
        {
            p: 0,
            pb: ["20px", 0],
            position: "relative",
            maxWidth: "100vw",
            maxHeight: scrollableBody
                ? [
                    // to force window scroll in xs breakpoint to avoid glitchy behaviour in mobile, place the first item with `none`
                    // `none`,
                    "calc(100dvh - ".concat(dialogMarginXs, " * 2)"),
                    "calc(100dvh - ".concat(dialogMargin, " * 2)"),
                ]
                : "none",
            gap: 0,
            gridTemplate: [
                " \n           \"title\" auto\n           \"customHeader\" auto\n           \"body\" 1fr\n           \"customFooter\" auto\n           \"secondaryActions\" auto\n           \"primaryActions\" auto\n         ",
                " \n           \"title title\" auto\n           \"customHeader customHeader\" auto\n           \"body body\" 1fr\n           \"customFooter customFooter\" auto\n           \"secondaryActions primaryActions\" auto\n           / 1fr auto\n         ",
            ],
        },
        sx,
    ]);
    return jsx(Grid, __assign({ ref: ref, sx: baseStyle }, props));
});

export { DialogLayout };
//# sourceMappingURL=DialogLayout.js.map
